import type { CheckReason, CheckResult } from './types';

/**
 * Wortlaut und Symbol je Ergebnis.
 *
 * Farbe allein trägt nicht: das Display ist bei Sonne schlecht ablesbar,
 * und rund acht Prozent der Männer sehen Rot und Grün nicht zuverlässig
 * auseinander. Jedes Ergebnis bekommt deshalb Farbe **und** Symbol **und**
 * Wort.
 */
export const RESULT_LABEL: Record<CheckResult, { word: string; icon: string }> = {
  green: { word: 'Berechtigt', icon: '✓' },
  yellow: { word: 'Bitte auswählen', icon: '?' },
  red: { word: 'Nicht berechtigt', icon: '✕' },
};

/** Klartext für den Grund. Das ist der Satz, den die Duty-Kraft sagt. */
export const REASON_TEXT: Record<CheckReason, string> = {
  not_found: 'Nicht auf der Liste',
  revoked: 'Karte gesperrt. Bitte zum Office',
  expired: 'Karte abgelaufen',
  not_yet_valid: 'Karte noch nicht gültig',
  wrong_area: 'Nicht für diesen Bereich berechtigt',
  ambiguous: 'Mehrere Personen möglich. Bitte auswählen',
  loose_id_match: 'Jamaat-ID weicht ab. Bitte bestätigen',
  already_checked_in: 'Bereits eingelassen',
};

export function reasonText(reason?: CheckReason): string | null {
  return reason ? REASON_TEXT[reason] : null;
}
